import { composeFieldPath } from '@northfork/basics'

export const tradeField = composeFieldPath([] as TradeEntryModel[])

export interface TradeEntryModel {
  id: keyof TradeEntryRow
  validityStatus: 'valid' | 'invalid' | 'warning'
  isEditable: boolean
  field: string
  value: string
  type: 'number' | 'string' | 'date'
  custody?: string
  trading?: string
  errorMessage: string
  thirdParty?: string
}

export interface TradeEntryRow {
  account: string
  transactionType: string
  entryDate: string
  settleDate: string
  postDate: string
  cusip: string
  cwanIdentifier?: string
  price: string
  units: string
  factor: string
  inventoryType?: string
  commission: string
  originationFee: string
  exitFee?: string
  exitFeeReceivable?: string
  drawFee?: string
  prepaymentPenaltyFee?: string
  prepaidInterest: string
  interestDue: string
  interestBearingInterestReserve?: string
  interestBearingPrincipalReserve?: string
  nonInterestBearingInterestReserve?: string
  nonInterestBearingPrincipalReserve?: string
  decimalAccrued?: string
  dollarAccrued?: string
  priceScalar?: string
  contractSize?: string
  proceeds: string
  clearwaterCounterParty?: string
  counterParty?: string
  amortTargetDate?: string
  amortTargetPrice?: string
  yield?: string
  amount?: string
  transTypeCode: string
  collateralBroker?: string
  drawType?: string
  reserveBalanceField?: string
  buyType?: string
  unfundedToFunded?: string
  interestReserveToFunded?: string
  capitalizationOfInterest?: string
  paymentInKind?: string
  dataSource?: string
}
